<template>
	<div :style="style" class="avatar-picture">
	</div>
</template>

<script>
export default {
	props: [
		'src'
	],
	computed: {
		style () {
			return `background-image:url('${this.src}')`
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/avatars/AvatarPicture.vue